export default __webpack_public_path__ + "5a0e9e05726ef7cf7462f25d3a4861e3.svg";